import { Component, OnInit } from '@angular/core';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'app-informes',
  templateUrl: './informes.component.html',
  styleUrls: ['./informes.component.scss']
})
export class InformesComponent implements OnInit {

  showInforme = null;

  constructor(
    private gtp: Gtp,
  ) { }

  ngOnInit(): void {    
    this.gtp.getMainOutletObs().subscribe(data => {
      this.setInforme(data);
      this.mobileConfig(data);
    });
  }

  setInforme(informe){
    this.showInforme = informe;
  }

  /**
   * Oculta el Main Sidebar
   */
  mobileConfig(hide=false){
    if (this.gtp.isMobile() && hide) {      
      this.gtp.setMainSidebar();
    }
  }

}
